import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionSirets, ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-sirets',
  templateUrl: 'cerfa-sirets.component.html',
  styleUrls: ['./cerfa-sirets.component.less', '../../../shared/common.less'],
})

export class CerfaSiretsComponent implements OnInit {
  @Input() sirets: ElectionSirets;
  @Output() siretsChange = new EventEmitter<ElectionSirets>();
  needPap: boolean = undefined;

  constructor() {}
  
  onSiretsChange() {
    this.siretsChange.emit(this.sirets);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  deleteAt(i) {
    this.sirets.sirets.splice(i, 1);
    this.onSiretsChange();
  }

  trackByIndex(index: number): number {
    return index;
  }

  
  ngOnInit(): void {
  }
}
